export default __webpack_public_path__ + "static/media/information--airport--g1.73af71fe.png";